export default {
  methods: {
    //DISPATCHES
    setError(err, prevent, actionEv) {
      if (!err || err.response.status >= 500) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      document.dispatchEvent(
        new CustomEvent("error-" + err.response.status, {
          detail: {
            preventDefault: prevent | false,
            callbackEvent: actionEv,
            data: err.response,
          },
        }),
      );
    },
  },
  mounted() {
    //LISTENERS
    //Re-direct user to the Login page
    document.addEventListener(
      "error-login-callback",
      function () {
        this.login(this.realm);
      }.bind(this),
    );

    document.addEventListener(
      "logout-callback",
      function () {
        this.logout();
      }.bind(this),
    );
  },
};
